import Hero from "../components/sections/Hero";
import WhyDholera from "../components/sections/WhyDholera";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import Founder from "../components/sections/Founder";
import Services from "../components/sections/Services";
import FeaturedProjects from "../components/sections/FeaturedProjects";
import Properties from "../components/sections/Properties";
import SiteVisitCTA from "../components/sections/SiteVisitCTA";

export default function HomePage({ onOpenLead }) {
  return (
    <div data-testid="home-page">
      <Hero onOpenLead={onOpenLead} />
      <WhyDholera />
      <WhyChooseUs />
      <Founder />
      <Services onOpenLead={onOpenLead} />
      <FeaturedProjects onOpenLead={onOpenLead} />
      <Properties onOpenLead={onOpenLead} compact />
      <SiteVisitCTA />
    </div>
  );
}
